import { generateUtilityClass, generateUtilityClasses } from '../../../utils/classes.esm.js';

function getDrawerUtilityClass(slot) {
  return generateUtilityClass('csg-tui-drawer', slot);
}
generateUtilityClasses('csg-tui-drawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);

export { getDrawerUtilityClass };
//# sourceMappingURL=drawer-classes.esm.js.map
